import React from 'react';

const ForceReloadModal = ({ onReload }) => {
  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2>Session Updated</h2>
        <p>Your session has been updated. Please reload the page to continue.</p>
        <button onClick={onReload} style={styles.button}>Reload Page</button>
      </div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  button: {
    marginTop: '20px',
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default ForceReloadModal;
